/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import VueLazyLoad from 'vue-lazyload';
import LightBox from 'vue-image-lightbox/src/components/LightBox.vue';

Vue.use(VueLazyLoad);
@Component({
    name: 'c-image-list',
    components: {
        LightBox,
    },
})
export default class ImageList extends Vue {
    @Prop() private images!: any[];

    private lightBoxImages: any[] = [];

    /**
     * Populate the lightboxImages when loaded.
     */
    public created(): void {
        for (const image of this.images) {
            this.lightBoxImages.push(
                {
                    thumb: image.presignedUrl,
                    src: image.presignedUrl,
                    srcset: image.presignedUrl,
                },
            );
        }
    }


    /**
     * Open the image in LightBox
     * @param index
     */
    public openGallery(index: number): void {
        const lightboxImg: any = this.$refs.lightbox;
        lightboxImg.showImage(index);
    }
}
